export const common = {
  nav: {
    features: 'Recursos',
    pricing: 'Preços',
    login: 'Entrar',
    getStarted: 'Começar Agora',
    backToHome: 'Voltar ao Início',
    leadGeneration: 'Geração de Leads'
  },
  hero: {
    badge: 'Powered by GPT-5',
    title: 'Sua Empresa no',
    titleHighlight: 'Piloto Automático',
    titleEnd: 'com Inteligência Artificial Real',
    subtitle: 'Atendimento, Vendas, Agendamento e CRM integrados no WhatsApp.',
    subtitleEnd: 'Deixe a IA trabalhar enquanto você escala.',
    watchDemo: 'Ver Demo em Ação',
    talkToConsultant: 'Falar com Consultor',
    stats: {
      support: 'Atendimento Ativo',
      reduction: 'Redução no Tempo',
      conversions: 'Mais Conversões',
      leads: 'Leads Perdidos'
    }
  },
  problem: {
    badge: 'O Problema Real',
    title: 'Você Está Perdendo Dinheiro',
    titleHighlight: 'Todos os Dias',
    subtitle: 'Enquanto você lê isso, leads estão sendo ignorados, vendas estão sendo perdidas e sua concorrência está usando IA para dominar o mercado.',
    items: {
      waiting: {
        title: 'Leads Esperando Demais',
        description: 'Clientes em potencial abandonam a conversa porque sua equipe não consegue responder rápido o suficiente.'
      },
      disorganized: {
        title: 'Equipe Desorganizada',
        description: 'Múltiplos atendentes, conversas perdidas, informações duplicadas e nenhum controle real sobre o processo.'
      },
      followups: {
        title: 'Follow-ups Esquecidos',
        description: 'Oportunidades valiosas escorregam pelos dedos porque ninguém lembrou de fazer o acompanhamento.'
      },
      chaotic: {
        title: 'WhatsApp Caótico',
        description: 'Centenas de conversas misturadas, impossível saber quem é lead quente, quem já comprou ou quem precisa de atenção.'
      }
    },
    warning: 'A cada minuto sem automação, você perde oportunidades',
    warningSubtitle: 'Empresas que implementam IA no atendimento crescem 3x mais rápido que a concorrência.'
  },
  solution: {
    badge: 'A Solução Completa',
    title: 'O Primeiro Sistema Operacional de IA',
    titleHighlight: 'All-in-One para WhatsApp',
    subtitle: 'Clone seu melhor vendedor, automatize seu CRM e escale sua receita sem contratar mais funcionários.',
    aiAgents: {
      title: 'AI Agents',
      description: 'Inteligência GPT-5 que entende áudio, texto e contexto. Não é um bot burro de botões - é uma IA que realmente conversa.',
      features: {
        context: 'Compreensão de contexto',
        natural: 'Respostas naturais',
        learning: 'Aprendizado contínuo'
      }
    },
    voiceAgents: {
      title: 'Voice Agents',
      description: 'Interação por voz ultra-realista via integração ElevenLabs. Seus clientes não vão acreditar que estão falando com uma IA.',
      features: {
        humanized: 'Voz humanizada',
        instant: 'Resposta instantânea',
        multilingual: 'Múltiplos idiomas'
      }
    },
    crm: {
      title: 'CRM Completo',
      description: 'Visão Kanban, pipelines e tags de leads diretamente na interface do chat. Tudo integrado, nada de ferramentas separadas.',
      features: {
        pipeline: 'Pipeline visual',
        automation: 'Automação de tarefas',
        analytics: 'Relatórios em tempo real'
      }
    },
    inbox: {
      title: 'Multi-Agent Inbox',
      description: 'Um número de WhatsApp, múltiplos agentes humanos ou IA trabalhando juntos. Colaboração perfeita em tempo real.',
      features: {
        distribution: 'Distribuição inteligente',
        handoff: 'Handoff IA-Humano',
        monitoring: 'Monitoramento em tempo real'
      },
      inputPlaceholder: 'Digite uma mensagem...',
      noConversation: 'Selecione uma conversa para começar'
    },
    chat: {
      user1: 'Olá! Gostaria de saber mais sobre seus serviços.',
      bot1: 'Olá! Fico feliz em ajudar! Oferecemos soluções completas de automação para WhatsApp com IA. Posso te mostrar como funciona?',
      user2: 'Sim, por favor! Como a IA entende o contexto?',
      bot2: 'Nossa IA usa GPT-5 para entender não apenas palavras, mas o contexto completo da conversa. Ela lembra de interações anteriores e adapta as respostas ao perfil de cada cliente. É como ter seu melhor vendedor trabalhando 24/7!',
      assistant: 'Julia da Automat',
      online: 'online',
      typing: 'Digite uma mensagem'
    },
    voice: {
      recording: 'gravando...',
      assistant: 'Assistente de Voz IA'
    }
  },
  features: {
    badge: 'Diferenciais Técnicos',
    title: 'Tecnologia de Ponta que',
    titleHighlight: 'Realmente Funciona',
    subtitle: 'Não é só mais uma ferramenta. É um ecossistema completo construído para escalar seu negócio.',
    scheduling: {
      title: 'Agendamento Inteligente',
      description: 'A IA acessa sua agenda e marca compromissos automaticamente. Sem idas e vindas, sem confusão.',
      stats: 'Economia de 15h/semana'
    },
    broadcast: {
      title: 'Broadcast & Remarketing',
      description: 'Mensagens em massa com filtros inteligentes para reativar leads frios e transformá-los em clientes.',
      stats: '40% de reativação'
    },
    sharedInbox: {
      title: 'Inbox Compartilhado',
      description: 'Dashboard para gestores monitorarem conversas em tempo real. Visibilidade total da operação.',
      stats: '100% de transparência'
    },
    analytics: {
      title: 'Analytics Avançado',
      description: 'Métricas detalhadas de performance, taxa de conversão e ROI. Decisões baseadas em dados reais.',
      stats: 'ROI médio de 380%'
    },
    security: {
      title: 'Segurança Enterprise',
      description: 'Criptografia de ponta a ponta, LGPD compliant e backup automático. Seus dados sempre protegidos.',
      stats: '99.9% uptime'
    },
    integrations: {
      title: 'Integrações Nativas',
      description: 'Conecte com seu CRM, ERP, calendário e ferramentas favoritas. Tudo sincronizado automaticamente.',
      stats: '50+ integrações'
    },
    cta: {
      title: 'Pronto para Decolar?',
      subtitle: 'Junte-se a centenas de empresas que já automatizaram seu atendimento e multiplicaram seus resultados.',
      button: 'Agendar Demonstração Gratuita'
    }
  },
  kanban: {
    badge: 'Experimente o Kanban Inteligente na Prática',
    title: 'CRM com Kanban e Inteligência Artificial',
    subtitle: 'Arraste, edite, filtre, crie e mova leads entre etapas. Veja o poder do nosso Kanban com IA e descubra como ele pode transformar sua gestão de vendas!',
    metrics: {
      totalLeads: 'Total de Leads',
      totalValue: 'Valor Total',
      conversion: 'Conversão',
      priority: 'Prioridade',
      inProgress: 'Em Andamento',
      performance: 'Performance',
      excellent: 'Excelente'
    },
    columns: {
      preQualified: 'Pré-Qualificados (IA)',
      initialContact: 'Contato Inicial',
      negotiation: 'Negociação',
      closing: 'Fechamento'
    },
    leads: {
      qualifiedByAI: 'Qualificado pela IA',
      aiMonitoring: 'Monitoramento IA',
      newLead: 'Lead novo, aguardando contato',
      warmLead: 'Lead aquecido, respondeu pesquisa',
      awaitingResponse: 'Aguardando resposta',
      coldLead: 'Lead frio, sem resposta',
      leadInAnalysis: 'Lead em análise',
      leadResolved: 'Lead resolvido',
      conversations: 'conversas',
      broadcasts: 'disparos',
      remarketing: 'remarketing',
      automations: 'automações',
      hot: 'Quente',
      warm: 'Morno',
      cold: 'Frio',
      high: 'Alta',
      medium: 'Média',
      low: 'Baixa',
      today: 'Hoje',
      total: 'Total',
      average: 'Média'
    }
  },
  scheduling: {
    badge: 'Agendamento Automatizado',
    title: 'Sistema de Agendamento Inteligente',
    subtitle: 'Permita que seus clientes agendem compromissos e serviços 24/7 pelo WhatsApp',
    chat: {
      user1: 'Olá! Gostaria de agendar um horário para corte de cabelo.',
      bot1: 'Claro! Vou te ajudar com o agendamento. Qual dia você gostaria de agendar?',
      user2: 'Quarta-feira que vem, por favor.',
      bot2: 'Perfeito! Temos os seguintes horários disponíveis na quarta-feira (15/05):',
      bot2b: 'Digite o horário desejado para confirmar seu agendamento.',
      user3: 'Vou escolher 14:30, por favor.',
      bot3: 'Ótimo! Seu agendamento foi confirmado:',
      confirmation: {
        title: 'Agendamento Confirmado',
        service: 'Serviço: Corte de Cabelo',
        date: 'Data: 15/05/2023 (Quarta-feira)',
        time: 'Horário: 14:30',
        location: 'Local: Visage Hair Studio',
        reminder: 'Você receberá um lembrete 2 horas antes'
      }
    },
    features: {
      publicPage: {
        title: 'Página Pública de Agendamento',
        description: 'Além do agendamento via WhatsApp, oferecemos uma página pública de agendamento personalizada para seus clientes',
        customization: {
          title: 'Customização Total',
          description: 'Cores, logo e layout personalizados'
        },
        publicAccess: {
          title: 'Acesso Público',
          description: 'Link único para compartilhar'
        },
        configurable: {
          title: 'Totalmente Configurável',
          description: 'Horários, serviços e disponibilidade'
        }
      },
      availability: {
        title: 'Disponibilidade 24/7',
        description: 'Seus clientes podem agendar serviços a qualquer hora do dia ou da noite, sem necessidade de intervenção humana.'
      },
      configurable: {
        title: 'Totalmente Configurável',
        description: 'Defina horários disponíveis, duração dos serviços, intervalos entre atendimentos e muito mais de acordo com suas necessidades.'
      },
      reminders: {
        title: 'Lembretes Automáticos',
        description: 'Reduza faltas com lembretes automáticos enviados antes dos horários agendados, aumentando a eficiência.'
      },
      control: {
        title: 'Controle Total',
        description: 'Gerencie todos os agendamentos facilmente, reagende, cancele ou confirme diretamente pelo sistema.'
      }
    },
    cta: 'Comece a enviar agora'
  },
  broadcast: {
    badge: 'Novidade',
    title: 'Disparos em Massa com Inteligência',
    subtitle: 'Alcance todos os seus clientes com mensagens personalizadas e eficientes',
    campaign: {
      header: 'Campanha de Marketing',
      name: 'Nome da Campanha',
      nameValue: 'Promoção Relâmpago de Inverno',
      message: 'Mensagem Personalizada',
      messageValue: 'Olá, {{name}}! 👋 Aproveite nossa promoção especial de inverno com 30% OFF em todos os produtos. Válido só hoje!',
      segmentation: 'Segmentação',
      segment1: 'Clientes ativos nos últimos 30 dias',
      segment2: 'Interessados em produtos de verão',
      progress: 'Progresso da campanha',
      recipients: 'destinatários',
      delivered: 'entregues',
      read: 'lidas'
    },
    features: {
      strategic: {
        title: 'Alcance Estratégico',
        description: 'Envie mensagens para milhares de contatos com segmentação inteligente, garantindo que a mensagem certa chegue à pessoa certa.'
      },
      realtime: {
        title: 'Métricas em Tempo Real',
        description: 'Acompanhe o desempenho de suas campanhas em tempo real com métricas detalhadas de entrega, leitura e engajamento.'
      },
      automation: {
        title: 'Automação Inteligente',
        description: 'Configure horários, intervalos e condições específicas para envio, otimizando as taxas de abertura e resposta.'
      },
      personalization: {
        title: 'Personalização Avançada',
        description: 'Use IA para criar mensagens personalizadas que ressoam com cada cliente individualmente, aumentando o engajamento e conversões.'
      }
    },
    cta: 'Comece a enviar agora'
  },
  socialProof: {
    badge: 'Resultados Comprovados',
    title: 'Números que Falam por Si',
    subtitle: 'Empresas reais, resultados reais. Veja o impacto da automação inteligente.',
    metrics: {
      responseTime: {
        value: '90%',
        label: 'Redução no Tempo de Resposta',
        description: 'De horas para segundos. Seus clientes nunca mais vão esperar.'
      },
      sales: {
        value: '30%',
        label: 'Aumento nas Vendas',
        description: 'Mais conversões, menos esforço. A IA trabalha 24/7 por você.'
      },
      leads: {
        value: '5x',
        label: 'Mais Leads Qualificados',
        description: 'Filtragem inteligente que identifica quem vai realmente comprar.'
      },
      responseRate: {
        value: '100%',
        label: 'Taxa de Resposta',
        description: 'Zero leads ignorados. Toda mensagem recebe atenção imediata.'
      }
    }
  },
  pricing: {
    badge: 'Planos e Preços',
    title: 'Escolha o Plano Ideal',
    titleHighlight: 'Para Seu Negócio',
    subtitle: 'Planos desenvolvidos para cada etapa do seu crescimento',
    starter: {
      name: 'Starter',
      description: 'Para consultórios ou profissionais liberais que desejam organizar o atendimento e agendamentos no WhatsApp.',
      price: 'R$ 597',
      perMonth: '/mês',
      setup: 'Setup único de R$ 497',
      sections: {
        profile: 'Perfil Ideal',
        capacity: 'Capacidade',
        team: 'Equipe',
        ai: 'Inteligência Artificial',
        features: 'Recursos'
      },
      features: {
        profile: 'Consultório ou Profissional Liberal',
        messages: 'Mensagens ilimitadas',
        capacity: '1 agenda / profissional',
        users: 'Usuários ilimitados',
        whatsapp: '1 número de WhatsApp',
        aiLevel: 'Triagem básica (tira dúvidas + agendamento)',
        ocr: 'Leitura de Guias (OCR): Não incluso',
        voiceAgent: 'Agente de Voz: Não (responde apenas por texto)',
        recall: 'Reativação (Recall): Manual'
      },
      cta: 'Começar Agora'
    },
    pro: {
      badge: '🔥 Mais Vendido',
      name: 'PRO',
      description: 'Ideal para clínicas e operações profissionais que precisam automatizar atendimento, vendas, agendamentos e triagem inteligente via WhatsApp.',
      price: 'R$ 997',
      perMonth: '/mês',
      setup: 'Setup único de R$ 897',
      sections: {
        profile: 'Perfil Ideal',
        capacity: 'Capacidade',
        team: 'Equipe',
        ai: 'Inteligência Artificial',
        features: 'Recursos'
      },
      features: {
        profile: 'Operações profissionais com atendimento ativo via WhatsApp',
        messages: 'Mensagens ilimitadas',
        capacity: 'Até 5 agendas / profissionais',
        capacityExtra: 'Agenda adicional: R$ 149/mês',
        users: 'Usuários ilimitados',
        whatsapp: 'Até 2 números de WhatsApp',
        whatsappExtra: 'Número adicional: R$ 149/mês',
        humanHandoff: 'Transferência automática para humanos',
        aiLevel: 'Assistente Clínica (leitura de exames + raciocínio)',
        ocr: 'Leitura de Guias (OCR): Incluso',
        voiceAgent: 'Agente de Voz: Sim',
        recall: 'Reativação (Recall): Automática'
      },
      cta: 'Contratar Agora'
    },
    scale: {
      badge: '👑 Premium',
      name: 'Scale',
      description: 'Para redes, franquias e operações de alto volume que precisam escalar atendimento e centralizar múltiplas unidades.',
      price: 'R$ 1.997',
      perMonth: '/mês',
      setup: 'Setup único de R$ 1.897',
      sections: {
        profile: 'Perfil Ideal',
        capacity: 'Capacidade',
        team: 'Equipe',
        ai: 'Inteligência Artificial',
        features: 'Recursos'
      },
      features: {
        profile: 'Redes, franquias ou alto volume',
        messages: 'Mensagens ilimitadas',
        capacity: 'Até 15 agendas / profissionais',
        capacityExtra: 'Agenda adicional: R$ 149/mês',
        users: 'Usuários ilimitados',
        whatsapp: 'Até 5 números de WhatsApp',
        whatsappExtra: 'Número adicional: R$ 149/mês',
        humanHandoff: 'Transferência automática para humanos',
        aiLevel: 'Assistente Clínica (leitura de exames + raciocínio)',
        ocr: 'Leitura de Guias (OCR): Incluso',
        voiceAgent: 'Agente de Voz: Sim',
        recall: 'Reativação (Recall): Automática'
      },
      cta: 'Escalar Agora'
    },
    guarantee: {
      title: 'Garantia de 7 dias',
      description: 'com devolução total do dinheiro.',
      risk: 'Risco Zero.'
    }
  },
  finalCTA: {
    badge: 'Última Chance',
    title: 'Pronto para Substituir o Caos',
    titleHighlight: 'pela Inteligência Artificial?',
    subtitle: 'Comece sua transformação hoje. Enquanto você hesita, seus concorrentes já estão automatizando e crescendo 3x mais rápido.',
    watchDemo: 'Ver Demo Completa Agora',
    talkToSpecialist: 'Falar com Especialista',
    features: {
      setup: 'Setup sem complicações',
      guarantee: 'Garantia de 7 dias',
      support: 'Suporte dedicado',
      secure: '100% seguro'
    }
  },
  footer: {
    description: 'O primeiro sistema operacional de IA completo para WhatsApp. Automatize atendimento, vendas e CRM com inteligência artificial de última geração.',
    address: {
      title: 'Endereço:',
      street: 'Rua Pais Leme, 215, 17 andar, Pinheiros',
      zip: 'CEP 05424-150',
      city: 'São Paulo - SP'
    },
    product: {
      title: 'Produto',
      features: 'Recursos',
      pricing: 'Preços',
      integrations: 'Integrações',
      api: 'API'
    },
    company: {
      title: 'Empresa',
      about: 'Sobre Nós',
      blog: 'Blog',
      careers: 'Carreiras',
      contact: 'Contato'
    },
    legal: {
      title: 'Legal',
      privacy: 'Privacidade',
      terms: 'Termos de Uso',
      security: 'Segurança',
      lgpd: 'LGPD'
    },
    copyright: '© 2025 Automat. Todos os direitos reservados.'
  },
  about: {
    title: 'Sobre Nós',
    subtitle: 'Somos um time apaixonado por tecnologia e client experience, que decidiu revolucionar o mercado através do atendimento de qualidade para todos.',
    mission: {
      title: 'Nossa Missão',
      p1: 'Democratizar o acesso à tecnologia de ponta em atendimento ao cliente, permitindo que empresas de todos os tamanhos ofereçam experiências excepcionais através da inteligência artificial.',
      p2: 'Acreditamos que cada interação com o cliente é uma oportunidade de criar conexões significativas e duradouras.'
    },
    values: {
      title: 'Nossos Valores',
      passion: {
        title: 'Paixão pelo Cliente',
        description: 'Colocamos o sucesso dos nossos clientes no centro de tudo que fazemos.'
      },
      innovation: {
        title: 'Inovação Constante',
        description: 'Buscamos sempre as melhores soluções tecnológicas para resolver problemas reais.'
      },
      collaboration: {
        title: 'Colaboração',
        description: 'Trabalhamos juntos, como um time, para alcançar resultados extraordinários.'
      }
    }
  },
  inbox: {
    clinic: 'Clínica Vitae',
    agentPanel: 'Painel de Agentes',
    search: 'Buscar por nome, número...',
    all: 'Todos',
    pending: 'Pendentes',
    mine: 'Meus',
    typeMessage: 'Digite uma mensagem...'
  }
};
